document.addEventListener("DOMContentLoaded", function() {
  /* ===== Hatolie - Hero + H1 ===== */
  const hatolieElements = document.querySelectorAll(
    'h1, .home-section__hero h1, .section-header__hero-title'
  );
  hatolieElements.forEach(el => {
    el.style.fontFamily = '"Hatolie", sans-serif';
    el.style.fontSize = '3em';
    el.style.lineHeight = '1.1';
    el.style.letterSpacing = '0.06em';
  });

  /* ===== Catchye - H2-H6 + Menu + Dropdowns ===== */
  const catchyeElements = document.querySelectorAll(
    'h2, h3, h4, h5, h6, .header__menu a, .site-nav__link, .site-nav__has-dropdown > .site-nav__link'
  );
  catchyeElements.forEach(el => {
    el.style.fontFamily = '"Catchye", sans-serif';
    if(el.tagName === 'H2') el.style.fontSize = '2em';
    else if(el.tagName === 'H3') el.style.fontSize = '1.75em';
    else el.style.fontSize = '1.4em';
    el.style.lineHeight = '1.25';
    el.style.letterSpacing = '0.05em';
  });

  /* ===== Times Sans Serif - Body Text ===== */
  const timesElements = document.querySelectorAll(
    'body, p, li, span, .rte p, .rte li, .card__content p, .section-content p, .footer p'
  );
  timesElements.forEach(el => {
    el.style.fontFamily = '"Times Sans Serif", serif';
    el.style.fontSize = '1.15em';
    el.style.lineHeight = '1.65';
    el.style.letterSpacing = '0.02em';
  });
});
